import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dException from "../Effect.Exception/index.js";
import * as Web$dDOM$dParentNode from "../Web.DOM.ParentNode/index.js";
import * as Web$dEvent$dEventTarget from "../Web.Event.EventTarget/index.js";
import * as Web$dHTML from "../Web.HTML/index.js";
import * as Web$dHTML$dHTMLDocument from "../Web.HTML.HTMLDocument/index.js";
import * as Web$dHTML$dHTMLElement from "../Web.HTML.HTMLElement/index.js";
import * as Web$dHTML$dWindow from "../Web.HTML.Window/index.js";
const selectElement = query => Effect$dAff._bind(Effect$dAff._liftEffect((() => {
  const $0 = Web$dDOM$dParentNode.querySelector(query);
  return () => {
    const $1 = Web$dHTML.window();
    const $2 = Web$dHTML$dWindow.document($1)();
    return $0($2)();
  };
})()))(mel => Effect$dAff._pure((() => {
  if (mel.tag === "Just") { return Web$dHTML$dHTMLElement._read(Data$dMaybe.Nothing, Data$dMaybe.Just, mel._1); }
  if (mel.tag === "Nothing") { return Data$dMaybe.Nothing; }
  $runtime.fail();
})()));
const runHalogenAff = /* #__PURE__ */ Effect$dAff.runAff_(v2 => {
  if (v2.tag === "Left") { return Effect$dException.throwException(v2._1); }
  if (v2.tag === "Right") { return () => {}; }
  $runtime.fail();
});
const awaitLoad = /* #__PURE__ */ Effect$dAff.makeAff(callback => () => {
  const $0 = Web$dHTML.window();
  const $1 = Web$dHTML$dWindow.document($0)();
  const rs = Web$dHTML$dHTMLDocument.readyState($1)();
  if (rs === "Loading") {
    const et = Web$dHTML.window();
    const listener = Web$dEvent$dEventTarget.eventListener(v => callback(Data$dEither.$Either("Right", undefined)))();
    Web$dEvent$dEventTarget.addEventListener("DOMContentLoaded")(listener)(false)(et)();
    const $2 = Effect$dAff._liftEffect(Web$dEvent$dEventTarget.removeEventListener("DOMContentLoaded")(listener)(false)(et));
    return v => $2;
  }
  callback(Data$dEither.$Either("Right", undefined))();
  return Effect$dAff.nonCanceler;
});
const awaitBody = /* #__PURE__ */ Effect$dAff._bind(awaitLoad)(() => Effect$dAff._bind(selectElement("body"))(body => {
  const $0 = Effect$dAff._throwError(Effect$dException.error("Could not find body"));
  if (body.tag === "Nothing") { return $0; }
  if (body.tag === "Just") { return Effect$dAff._pure(body._1); }
  $runtime.fail();
}));
export {awaitBody, awaitLoad, runHalogenAff, selectElement};
